// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { createClientLogger } from '@azure/logger';

/**
 * @private
 */
export const compositeLogger = createClientLogger('communication-react:composite');